import { LexicalEditor } from 'lexical'
import { convertLexicalToDBJson } from '@/features/screenplay/components/editor/utils/JsonUtils'
import { PdfService } from '@/shared/services/pdf.service'
import { StoryPDFTemplate } from '../../pdf/StoryPDFTemplate'

export const handleDownload = async (
    fileName: string,
    editor: LexicalEditor,
    authorName?: string
) => {
    if (typeof window !== 'undefined') {
        try {
            console.log('Generating Story PDF from AST...')
            const editorState = editor.getEditorState()

            let blocks: any[] = []
            editorState.read(() => {
                // Reuse the conversion logic from screenplay as the nodes are similar/identical in structure
                blocks = convertLexicalToDBJson(editorState.toJSON())
            })

            console.log('Extracted Story Blocks:', blocks.length)

            const brandLogoBase64 = await PdfService.fetchBrandLogoBase64()

            const pdfDoc = (
                <StoryPDFTemplate
                    blocks={blocks}
                    brandLogoBase64={brandLogoBase64}
                    projectTitle={fileName}
                    authorName={authorName}
                />
            )
            const documentTitle = `${fileName}-story.pdf`

            await PdfService.downloadReactPdfDocument(pdfDoc, documentTitle)

            console.log('Story PDF downloaded successfully')
        } catch (error) {
            console.error('Error downloading Story PDF:', error)
            alert('Failed to download Story PDF.')
        }
    }
}
